import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable, Optional } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CommonServiceService } from 'src/app/shared/service/common-service.service';
import { HttpUtil } from 'src/app/shared/service/common.http';
import { GlobalCacheService } from 'src/app/shared/service/global-cache.service';
import { UtilService } from 'src/app/shared/utils/util.service';
import { ProductService } from '../jiaxuan/product/product.service';
import { HandleError, HttpErrorHandler } from 'src/app/shared/service/http-error-handler.service'
import { catchError } from 'rxjs/operators';
import { HttpHeaders, HttpRequest } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class IntroducesService {

  constructor(
    private httpUtil: HttpUtil,
    private httpErrorHandler: HttpErrorHandler,
    private cookieService: CookieService,
    private globalCacheService: GlobalCacheService,
    public commonService: CommonServiceService,
    public utilService: UtilService,
    public productService: ProductService,
    @Optional()
    @Inject(APP_BASE_HREF)
    origin: string
  ) {
    this.handleError = httpErrorHandler.createHandleError('WeeklyService')
    this.host = `${origin}`
  }

  private handleError: HandleError
  private host = ''
  public api = {
    sendEmail: () => `${this.host}/a/sendEmail`,
  }

  // 发送邮件
  sendEmail(params): Promise<any> {

    const req = new HttpRequest('POST', this.api.sendEmail(), params, {
      headers: new HttpHeaders()
    });
    return this.httpUtil
      .request(req)
      .pipe(catchError(this.handleError('sendEmail', {})))
      .toPromise()
      .then((res: any) => (res.body.code === 0 ? res : Promise.reject(res)))
  }

  disposeSendEmailData(pageData, forms = [], data) {
    const { emailTemplete, emailTitle } = pageData;
    const formData = new FormData();

    forms.filter(item => item.type === 'upload').forEach(item => {
      const files = data[item.key];
      if (Array.isArray(files) && files.length) {
        files.forEach(file => {
          formData.append('attachments', file)
        })
      }
    })

    formData.append('subject', emailTitle || 'contact us request');
    formData.append('body', this.renderEmailTemplete(emailTemplete, data));
    formData.append('merchantId', this.commonService.getLocalStorageByKey('merchantId'))
    return formData;
  }

  renderEmailTemplete(template, data) {
    return String(template || '').replace(/\{\{(\w+)\}\}/g, (match, key) => {
      return data.hasOwnProperty(key) ? data[key] : match;
    });
  }
}
